// advanceFrame — the "save & advance" orchestration shared by the Save Current
// Frame button and the Space keyboard shortcut.
//
// On each call it: (1) marks the current frame saved (green), (2) autosaves the
// draft (the "temporal file" of progress), and (3) advances to the next unsaved
// frame. It steps forward to the next still-unsaved frame; when none lies ahead
// it wraps to the first untouched (grey) frame, then the first
// touched-but-unsaved (orange) frame. Once every frame is saved it opens the
// completion dialog (Cancel / Submit).
//
// A module-level in-flight guard prevents overlapping runs — e.g. holding Space
// (key repeat) or double-clicking the button while the async draft save is
// pending.

import { useStore } from '../store';
import { editedFrameSet } from '../store/edits';
import { nextSaveTarget } from '../store/video';
import { saveDraft } from './draft';

let inFlight = false;

export async function advanceFrame(): Promise<void> {
  if (inFlight) return;
  inFlight = true;
  try {
    const before = useStore.getState();
    before.commitFrameSeeds(before.currentFrame);
    before.markAudited(before.currentFrame);

    const s = useStore.getState();
    await saveDraft(s);

    const edited = [...editedFrameSet(s)];
    const target = nextSaveTarget(
      s.navigableFrames,
      s.totalFrames,
      s.auditedFrames,
      edited,
      s.currentFrame
    );
    if (target === null) s.setCompletionOpen(true);
    else s.setCurrentFrame(target);
  } finally {
    inFlight = false;
  }
}
